import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/NotFound'
import Help from '@/components/Help'
import ShopsIndex from '@/components/Shops/Index'
import ShopsShow from '@/components/Shops/Show'
import ShopRequestsNew from '@/components/ShopRequests/New'
import ShopRequestsThanks from '@/components/ShopRequests/Thanks'
import AdminShopsIndex from '@/components/Admin/Shops/Index'
import AdminShopsEdit from '@/components/Admin/Shops/Edit'
import AdminShopRequestsIndex from '@/components/Admin/ShopRequests/Index'
import AdminShopRequestsShopsNew from '@/components/Admin/ShopRequests/Shops/New'
import AdminCommentRequestsIndex from '@/components/Admin/CommentRequests/Index'
import AdminCommentRequestsCommentsNew from '@/components/Admin/CommentRequests/Comments/New'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/',
      name: 'ShopsIndex',
      component: ShopsIndex
    },
    {
      path: '/shops/:id',
      name: 'ShopsShow',
      component: ShopsShow
    },
    {
      path: '/shop_requests/new',
      name: 'ShopRequestNew',
      component: ShopRequestsNew
    },
    {
      path: '/shop_requests/thanks',
      name: 'ShopRequestsThanks',
      component: ShopRequestsThanks
    },
    {
      path: '/admin/shops/',
      name: 'AdminShopsIndex',
      component: AdminShopsIndex
    },
    {
      path: '/admin/shops/:id/edit',
      name: 'AdminShopsEdit',
      component: AdminShopsEdit
    },
    {
      path: '/admin/shop_requests',
      name: 'AdminShopRequestsIndex',
      component: AdminShopRequestsIndex
    },
    {
      path: '/admin/shop_requests/:id/shops/edit',
      name: 'AdminShopRequestsShopsNew',
      component: AdminShopRequestsShopsNew
    },
    {
      path: '/admin/comment_requests',
      name: 'AdminCommentRequestsIndex',
      component: AdminCommentRequestsIndex
    },
    {
      path: '/admin/comment_requests/:id/comments/new',
      name: 'AdminCommentRequestsCommentsNew',
      component: AdminCommentRequestsCommentsNew
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js